import { TCondition } from '../types';
import { IApplicationState } from '../../../../types/types';
import { EHintKey, getHintConfig } from '../constants';
import { getHintCanShow } from '../store/hint/selectors/getHintCanShow';
import { COMMENTS_COLUMN_VIEW_MIN_WIDTH } from '../../../../const';
import { root } from '../../../../store/constants';

export const asideColumnToggleCondition: TCondition = (
    state: IApplicationState
) => {
    const hint = getHintConfig(EHintKey.ASIDE_COLUMN_TOGGLE);
    if (!hint || root._innerWidth <= COMMENTS_COLUMN_VIEW_MIN_WIDTH) return false;

    return !!getHintCanShow(state, EHintKey.ASIDE_COLUMN_TOGGLE);
};
